module.exports = __webpack_public_path__ + "static/media/non-accouncements.bcd359ba.png";